import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';

/** The interfaces this application ships. Order is the order of the language menu. */
export const languages = [
  { locale: 'fr', label: 'Francais', flag: '/images/fr.svg' },
  { locale: 'en', label: 'English', flag: '/images/gb.svg' },
] as const;

export type Locale = (typeof languages)[number]['locale'];

/** Same key as the other Kersia frontends, so a colleague's choice carries over. */
const STORAGE_KEY = 'preferredLocale';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    supportedLngs: languages.map((language) => language.locale),
    fallbackLng: 'en',
    // The browser reports en-GB, fr-FR and the like; the catalogues are per language.
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: STORAGE_KEY,
    },
    interpolation: {
      // React escapes on render already.
      escapeValue: false,
    },
    returnEmptyString: false,
    returnNull: false,
  });

/**
 * Keeps <html lang> and the browser tab in step. The lang attribute is what a screen reader and the
 * browser's own tooling read; the title is what a bookmark keeps.
 */
function applyDocumentLanguage(locale: string) {
  if (typeof document === 'undefined') {
    return;
  }

  document.documentElement.lang = locale;
  document.title = i18n.t('app.name');
}

applyDocumentLanguage(i18n.resolvedLanguage ?? 'en');
i18n.on('languageChanged', applyDocumentLanguage);

export default i18n;
